<template>
    <Head title="Log in" />

    <BreezeValidationErrors class="mb-4" :show="true" />

    <div v-if="$page.props.flash.error" class="mb-4 rounded-md bg-red-50 p-4 text-sm text-red-700">
        {{ $page.props.flash.error }}
    </div>

    <div v-if="$page.props.flash.message" class="alert">
        {{ $page.props.flash.message }}
    </div>

    <div v-if="status" class="mb-4 text-sm text-green-600">
        {{ status }}
    </div>

    <form v-if="!sso.force" @submit.prevent="submit">
        <div>
            <BreezeLabel for="email" value="Email" />
            <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="mt-4">
            <BreezeLabel for="password" value="Password" />
            <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
        </div>

        <div class="block mt-4">
            <label class="flex items-center">
                <BreezeCheckbox name="remember" v-model:checked="form.remember" />
                <span class="ml-2 text-sm text-gray-600">Remember me</span>
            </label>
        </div>

        <div class="flex items-center justify-end mt-4">
            <Link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                Forgot your password?
            </Link>

            <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Log in
            </BreezeButton>
        </div>
    </form>

    <div v-if="sso.google || sso.microsoft" :class="sso.force ? 'mt-0' : 'mt-6'" class="space-y-3">
        <div v-if="!sso.force" class="relative my-4">
            <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm">
                <span class="bg-white px-2 text-gray-500">or sign in with</span>
            </div>
        </div>

        <SsoProviderButton
            v-if="sso.google"
            provider="google"
            :href="route('sso.google.redirect')"
        />

        <SsoProviderButton
            v-if="sso.microsoft"
            provider="microsoft"
            :href="route('sso.microsoft.redirect')"
        />
    </div>
</template>

<script>
import BreezeButton from '@/Components/Button.vue'
import BreezeCheckbox from '@/Components/Checkbox.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import SsoProviderButton from '@/Components/SsoProviderButton.vue'
import { Head, Link } from '@inertiajs/vue3';

export default {
    layout: BreezeGuestLayout,

    components: {
        BreezeButton,
        BreezeCheckbox,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        SsoProviderButton,
        Head,
        Link,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
        sso: {
            type: Object,
            default: () => ({
                google: false,
                microsoft: false,
                force: false,
            }),
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('login'), {
                onFinish: () => this.form.reset('password'),
            })
        }
    }
}
</script>
